var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 28.75C11 28.0596 11.5596 27.5 12.25 27.5L27.25 27.5C27.9404 27.5 28.5 28.0596 28.5 28.75C28.5 29.4404 27.9404 30 27.25 30L12.25 30C11.5596 30 11 29.4404 11 28.75ZM15.1161 19.1161C15.6043 18.628 16.3957 18.628 16.8839 19.1161L18.5 20.7322L18.5 11.25C18.5 10.5596 19.0596 10 19.75 10C20.4404 10 21 10.5596 21 11.25L21 20.7322L22.6161 19.1161C23.1043 18.628 23.8957 18.628 24.3839 19.1161C24.872 19.6043 24.872 20.3957 24.3839 20.8839L20.6339 24.6339C20.3995 24.8683 20.0815 25 19.75 25C19.4185 25 19.1005 24.8683 18.8661 24.6339L15.1161 20.8839C14.628 20.3957 14.628 19.6043 15.1161 19.1161Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default __webpack_public_path__ + "static/media/icon-download-2.69cc3f4127361968ce21d47c15c3b3f2.svg";
export { ForwardRef as ReactComponent };